import React, { useState } from 'react';

type Props = {
  initial?: React.CSSProperties;
  show?: React.CSSProperties;
};

const defaultInitial = { opacity: 0, transition: '180ms opacity' };
const defaultShow = { opacity: 1, transition: '180ms opacity' };

/**
 * A simple wrapper around an `img` tag that will fade in the image
 * after it has loaded from the network to avoid the dialup era
 * "load from top to bottom" visual.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const FadeImage = (props: Props & any) => {
  const [show, setShow] = useState(false);

  let style = props.initial ?? defaultInitial;

  if (show) {
    style = props.show ?? defaultShow;
  }

  return <img {...props} onLoad={() => setShow(true)} style={style} />;
};

export default FadeImage;
